import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as loginActions from '../../actions/authActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Row, Col, Alert } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import ChangePasswordForm from './ChangePasswordForm';

class ChangePasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      credentials: {
        oldPass: '',
        newPass: '',
        confirmPass: '',
      },
      errors: {},
    };
  }

  updateCredentialState = (event) => {
    const field = event.target.id;
    let credentials = Object.assign({}, this.state.credentials);
    credentials[field] = event.target.value;
    this.setState({ credentials: credentials });
  };

  formIsValid() {
    const { credentials } = this.state;
    let errors = {};
    let isValid = true;

    if (credentials.oldPass === '') {
      errors.oldPass = 'Enter old password';
      isValid = false;
    }
    if (credentials.newPass === '') {
      errors.newPass = 'Enter new password';
      isValid = false;
    }
    if (credentials.confirmPass === '') {
      errors.confirmPass = 'Confirm password';
      isValid = false;
    }
    if (credentials.confirmPass !== credentials.newPass) {
      errors.confirmPass = 'New passwords do not match.';
      isValid = false;
    }
    if (credentials.oldPass === credentials.newPass) {
      errors.newPass = 'New password must be different.';
      isValid = false;
    }
    if (credentials.newPass.length < 10 || credentials.newPass.length > 32) {
      errors.newPass = 'Password should be between 10 and 32 characters';
      isValid = false;
    }
    let hasUpper = /[A-Z]/.test(credentials.newPass);
    let hasLower = /[a-z]/.test(credentials.newPass);
    let hasNumber = /\d/.test(credentials.newPass);
    let hasSymbols = /\W/.test(credentials.newPass);
    if (hasUpper + hasLower + hasNumber + hasSymbols < 4) {
      errors.newPass =
        'Password should contain uppercase letters, lowercase letters, numbers, and symbols.';
      isValid = false;
    }
    this.setState({ errors: errors });
    return isValid;
  }

  changePassword = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    this.props.actions
      .changePassword(
        this.state.credentials.oldPass,
        this.state.credentials.newPass
      )
      .then(() => {
        toast.success('Password changed successfully. Please login again.');
        this.props.history.push('/login');
      })
      .catch((error) => {
        toast.error(error.response.data);
      });
  };

  render() {
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Change Password</h1>
            </Col>
          </Row>
          <Row>
            <Col md={2} />
            <Col md={8}>
              <Alert color="info">
                Password must be 10 to 32 characters and must contain at least
                one uppercase letter, one lowercase letter, one number, and one
                symbol.
              </Alert>
            </Col>
          </Row>
          <ChangePasswordForm
            credentials={this.state.credentials}
            onChange={this.updateCredentialState}
            onLogin={this.changePassword}
            loggingIn={false}
            errors={this.state.errors}
          />
        </Container>
      </div>
    );
  }
}

ChangePasswordPage.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch),
  };
}

export default withRouter(
  connect(null, mapDispatchToProps)(ChangePasswordPage)
);



// WEBPACK FOOTER //
// ./src/components/login/ChangePasswordPage.js